module.exports = __webpack_public_path__ + "static/media/back arrow.2dc0dd7f.svg";